import React, { useState, useEffect } from 'react';
import Intro from './Intro';
import Home from './Home';
import About from './About';
import Technology from './Technology';
import Contact from './Contact';
import Navbar from './Navbar';
import Background from './Background';
import Doctors from './Doctors';
import RoboticSpinal from './RoboticSpinal';
import Emteslla from './Emteslla';
import './App.css';

const App = () => {
  const [phase, setPhase] = useState('intro');
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    if (phase === 'home') {
      document.body.style.overflowY = 'auto';
      window.location.hash = currentPage;
    } else {
      document.body.style.overflow = 'hidden';
      if (window.location.hash) {
        window.history.replaceState(null, null, window.location.pathname);
      }
    }
  }, [phase, currentPage]);

  const handleEnterSite = () => {
    setPhase('transitioning-out-intro');
    setTimeout(() => {
      setPhase('building-world');
      setTimeout(() => {
        setPhase('home');
      }, 2000);
    }, 1200);
  };

  return (
    <div className="main-wrapper">

      {phase === 'home' && (
        <Navbar onNavigate={setCurrentPage} activePage={currentPage} />
      )}

      {(phase === 'intro' || phase === 'transitioning-out-intro') && (
        <Intro
          onEnter={handleEnterSite}
          exiting={phase === 'transitioning-out-intro'}
        />
      )}

      <Background phase={phase} />

      {(phase === 'building-world' || phase === 'home') && (
        <div className={`home-layer ${phase === 'home' ? 'active' : ''}`}>

          {currentPage === 'home' && <Home onNavigate={setCurrentPage} />}
          {currentPage === 'about' && <About />}
          {currentPage === 'technology' && <Technology />}
          {currentPage === 'contact' && <Contact />}
          {currentPage === 'doctors' && <Doctors />}
          {currentPage === 'robotic-spinal' && <RoboticSpinal />}
          {currentPage === 'Emteslla' && <Emteslla />}

        </div>
      )}

    </div>
  );
};

export default App;